import React from 'react';
import { message } from 'antd';
import { FormOutlined, AppstoreAddOutlined, TransactionOutlined } from '@ant-design/icons';
import AppIconGroup from '../../components/app-icon-group';
import List from './list';
import SwitchShop from '../shop/switch-shop';
import can from '../../components/ability';
import { SafeStorage } from '../../utils/jsbridge';
import getCurrentShop from '../shop/get-current-shop';
import getVersionMeta from '../../utils/get-version-meta';

const iconStyle = {
    fontSize: 28,
}

export default () => {
    const accId = window.__baseInfo.accId;
    const [shopId, setShopId] = React.useState(null);
    const [goodsList, setGoodsList] = React.useState({});

    const version = getVersionMeta();
    const versionCheck = async () => {

        if(goodsList?.count >= version.goods) {
            message.error('当前版本已达到最大商品数，请联系销售升级版本');
        }else {
            window.location.href = '/goods/create';
        }
    }

    React.useEffect(() => {
        const fetchShopStore = async () => {
            try {
                let shopStore = await getCurrentShop();
                console.log('Current shop:', shopStore);
                setShopId(shopStore ? shopStore.shopId : null);
            } catch (e) {
                console.error('Failed to parse shop store:', e);
            }
        };
        
        fetchShopStore();
    }, []);

    return (
        <div>
            <SwitchShop onSwitch={(shop) => setShopId(shop.shopId)} />
            
            {/* 快捷操作 - iOS 风格图标组 */}
            <div className="mt-3 mb-4">
                <AppIconGroup 
                    items={[
                        can('create', 'goods') && {
                            id: 1,
                            onClick: versionCheck,
                            title: '新建商品',
                            icon: <FormOutlined />,
                            color: 'from-blue-500 to-blue-600'
                        },
                        can('proxy', 'goods') && {
                            id: 2,
                            href: '/goods/proxy',
                            title: '代理商品',
                            icon: <TransactionOutlined />,
                            color: 'from-green-500 to-green-600'
                        },
                        can('create', 'goods') && {
                            id: 3,
                            href: '/category',
                            title: '分类管理',
                            icon: <AppstoreAddOutlined />,
                            color: 'from-purple-500 to-purple-600'
                        }
                    ].filter(Boolean)}
                    cols="3-3-3-3-3"
                />
            </div>
            
            <List accId={accId} shopId={shopId} onChange={(res) => setGoodsList(res)} />
        </div>
    )
}